import { isLocalUrl } from '../localjs';

export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: [''],
    itemsPerPanel: 1,
    maxItemsVisible: 1,
    showDescription: true,
    moreButton: {
      visible: true,
      text: 'learn more',
    },
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    buyNowButton: false,

    cardWidgetLoaded: function (data) {
      const widgetData = data.items;

      if (widgetData.length < 1) {
        $(`#${widgetName}`).remove();
        $('.tier-3-container').remove();
      } else {
        createCustomSeo(widgetData);
      }
    },
  });

  function createCustomSeo(widgetData) {
    const { Title, Description, URL } = widgetData[0];
    const $seo = $(`#${widgetName}`).find('.card-widget-item');
    const urlAttribute = isLocalUrl(URL) ? '' : "target='_blank'";
    const buttonHTML = URL ? `<a href="${URL}" class="button" ${urlAttribute}>Learn More</a>` : '';

    $seo.replaceWith(`
      <h1 class="seo-title">${Title}</h1>
      <p class="seo-description">${Description}</p>
      ${buttonHTML}
    `);
  }
}
